import { gate } from 'hub-http/gates';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
export const GATES = {
  WEB_VISITORS: gate('CRM:Segments:WebVisitors'),
  WEBSITE_PAGES: gate('Personalize:WebsitePages'),
  CONTEXT_LAYER_DEMO: gate('Personalize:ContextLayerDemo')
};
export const READ_SCOPES = {
  [ASSET_TYPES.LANDING_PAGE]: 'landingpages-access',
  [ASSET_TYPES.WEB_INTERACTIVE]: 'calls-to-action-read',
  [ASSET_TYPES.WEBSITE_PAGE]: 'sitepages-access'
};
export const WRITE_SCOPES = {
  [ASSET_TYPES.LANDING_PAGE]: ['landingpages-write', 'landing-pages-personalization-access'],
  [ASSET_TYPES.WEB_INTERACTIVE]: ['calls-to-action-edit'],
  [ASSET_TYPES.WEBSITE_PAGE]: ['pages-write', 'site-pages-personalization-access']
};